import React from 'react';
import UpdateInventory from './UpdateInventory';
import CheckInventory from './CheckInventory';

const InventoryManagement = ({ location, onBack }) => {
    // Define stores based on location
    const getStoresByLocation = () => {
        switch(location) {
            case 'trueliberty':
                return [
                    { value: 'TL_UP', label: 'TL UP' },
                    { value: 'TL_DOWN_R', label: 'TL DOWN-R' },
                    { value: 'TL_DOWN_C', label: 'TL DOWN-C' },
                    { value: 'TL_DOWN_L', label: 'TL DOWN-L' }
                ];
            case 'royaltech':
                return [
                    { value: 'ROYALTECH_MAIN', label: 'RoyalTech Main' }
                ];
            case 'shuwaikh':
                return [
                    { value: 'SHUWAIKH_RACK_1', label: 'SHUWAIKH RACK 1' },
                    { value: 'SHUWAIKH_RACK_2', label: 'SHUWAIKH RACK 2' },
                    { value: 'SHUWAIKH_RACK_3', label: 'SHUWAIKH RACK 3' }
                ];
            case 'bahman':
                return [
                    { value: 'BAHMAN_RACK_1', label: 'BAHMAN RACK 1' },
                    { value: 'BAHMAN_RACK_2', label: 'BAHMAN RACK 2' },
                    { value: 'BAHMAN_RACK_3', label: 'BAHMAN RACK 3' },
                    { value: 'BAHMAN_RACK_4', label: 'BAHMAN RACK 4' },
                    { value: 'BAHMAN_RACK_5', label: 'BAHMAN RACK 5' }
                ];
            default:
                return [];
        }
    };

    const getLocationName = () => {
        switch(location) {
            case 'trueliberty':
                return 'True Liberty';
            case 'royaltech':
                return 'RoyalTech';
            case 'shuwaikh':
                return 'Shuwaikh Store';
            case 'bahman':
                return 'Bahman Store';
            default:
                return '';
        }
    };

    // Map location to backend location parameter
    const getBackendLocation = () => {
        switch(location) {
            case 'trueliberty':
                return 'trueliberty';
            case 'royaltech':
                return 'royaltech';
            case 'shuwaikh':
                return 'shuwaikh';
            case 'bahman':
                return 'bahman';
            default:
                return '';
        }
    };

    const stores = getStoresByLocation();
    const locationName = getLocationName();
    const backendLocation = getBackendLocation();

    return (
        <div>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                maxWidth: '800px',
                margin: '0 auto 20px auto',
                padding: '0 20px'
            }}>
                <button
                    onClick={onBack}
                    style={{
                        padding: '10px 20px',
                        fontSize: '16px',
                        backgroundColor: '#6c757d',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    ← Back to Locations
                </button>
                <div style={{
                    padding: '10px 25px',
                    fontSize: '16px',
                    background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                    color: '#fff',
                    border: '2px solid #1a3461',
                    borderRadius: '25px',
                    fontWeight: '600',
                    boxShadow: '0px 4px 10px rgba(30, 60, 114, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <span style={{ opacity: 0.9, fontSize: '14px' }}>Current Location:</span>
                    <span style={{ fontSize: '16px' }}>{locationName}</span>
                </div>
            </div>

            <UpdateInventory stores={stores} location={backendLocation} />
            <CheckInventory location={backendLocation} />
        </div>
    );
};

export default InventoryManagement;